(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Save the order note when the field changes. Delegated on document so it
     survives the drawer panel being re-rendered after cart updates. */
  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-ss-cart-note]');
    if (!field) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: field.value })
    }).catch(function () {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  function openMegas() {
    return document.querySelectorAll('details[data-ss-mega][open]');
  }

  document.addEventListener('click', function (e) {
    openMegas().forEach(function (details) {
      if (!details.contains(e.target)) details.removeAttribute('open');
    });
  });

  var hoverOK = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseover', function (e) {
    if (!hoverOK.matches) return;
    var mega = e.target.closest && e.target.closest('details[data-ss-mega]');
    if (mega && !mega.contains(e.relatedTarget)) mega.setAttribute('open', '');
  });

  document.addEventListener('mouseout', function (e) {
    if (!hoverOK.matches) return;
    var mega = e.target.closest && e.target.closest('details[data-ss-mega]');
    if (mega && !mega.contains(e.relatedTarget)) mega.removeAttribute('open');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openMegas().forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    function initCountryProvince(fields) {
      var countrySelect = fields.querySelector('[data-ss-country-select]');
      var provinceWrapper = fields.querySelector('[data-ss-province-wrapper]');
      var provinceSelect = fields.querySelector('[data-ss-province-select]');
      if (!countrySelect || !provinceWrapper || !provinceSelect) return;

      function setSelectDefault(select, value) {
        if (!value) return;
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value || select.options[i].text === value) {
            select.selectedIndex = i;
            return;
          }
        }
      }

      function updateProvinces(useDefault) {
        var selected = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];
        try {
          provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';

        if (!provinces.length) {
          provinceWrapper.hidden = true;
          return;
        }

        provinces.forEach(function (province) {
          var option = document.createElement('option');
          option.value = province[0];
          option.textContent = province[1];
          provinceSelect.appendChild(option);
        });

        provinceWrapper.hidden = false;

        if (useDefault) {
          setSelectDefault(provinceSelect, provinceSelect.getAttribute('data-default'));
        }
      }

      setSelectDefault(countrySelect, countrySelect.getAttribute('data-default'));
      updateProvinces(true);

      countrySelect.addEventListener('change', function () {
        updateProvinces(false);
      });
    }

    document.querySelectorAll('[data-ss-address-fields]').forEach(initCountryProvince);

    document.querySelectorAll('[data-ss-details-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        var details = button.closest('details');
        if (details) details.open = false;
      });
    });

    document.querySelectorAll('[data-ss-address-delete]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var message = form.getAttribute('data-confirm') || '';
        if (message && !window.confirm(message)) {
          event.preventDefault();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-ss-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.href;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ss-contact-body]').forEach(function (field) {
    if (field.value.trim() !== '') return;
    var params = new URLSearchParams(window.location.search);
    var prefill = params.get('contact[body]');
    if (prefill) field.value = prefill;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (function () {
    var recover = document.querySelector('[data-ss-recover]');
    if (!recover) return;
    if (window.location.hash === '#recover' || recover.querySelector('[data-ss-recover-open]')) {
      recover.open = true;
    }
    var summary = recover.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function () {
        if (!recover.open) {
          window.history.replaceState(null, '', '#recover');
        } else {
          window.history.replaceState(null, '', window.location.pathname);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    'use strict';

    function initMainProduct(root) {
      if (root.dataset.ssInit) return;
      root.dataset.ssInit = 'true';

      var form = root.querySelector('form[data-ss-atc]');
      var variantsEl = root.querySelector('[data-ss-variants]');
      var variants = [];
      try {
        variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      } catch (err) {
        variants = [];
      }

      var idInput = root.querySelector('[data-ss-variant-id]');
      var qtyInput = root.querySelector('[data-ss-qty-input]');
      var qtyValue = root.querySelector('[data-ss-qty-value]');
      var priceBox = root.querySelector('[data-ss-price]');
      var buyBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ss-buy-btn]'));
      var notify = root.querySelector('[data-ss-notify]');
      var stockCard = root.querySelector('[data-ss-stock]');
      var stockQty = root.querySelector('[data-ss-stock-qty]');
      var stockFill = root.querySelector('[data-ss-stock-fill]');
      var nudge = root.querySelector('[data-ss-nudge]');
      var track = root.querySelector('[data-ss-track]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ss-dot]'));
      var sticky = root.querySelector('[data-ss-sticky]');
      var stickyPrice = root.querySelector('[data-ss-sticky-price]');
      var stickyStock = root.querySelector('[data-ss-sticky-stock]');
      var mainAtc = form ? form.querySelector('[data-ss-buy-btn]') : null;
      var scarcityMax = parseInt(root.dataset.scarcityThreshold, 10) || 0;
      var thresholdFallback = parseInt(root.dataset.freeShippingThreshold, 10) || 0;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function money(cents) {
        if (window.SS && window.SS.money) return window.SS.money(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      function getQty() {
        return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      }

      function currentVariant() {
        if (!idInput) return null;
        var id = Number(idInput.value);
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) return variants[i];
        }
        return null;
      }

      function isScarce(v) {
        return (
          !!v &&
          v.inventory_management === 'shopify' &&
          v.inventory_policy === 'deny' &&
          v.inventory_quantity > 0 &&
          v.inventory_quantity <= scarcityMax
        );
      }

      function updateNudge(total) {
        if (!nudge) return;
        var threshold =
          (window.SS && window.SS.settings && window.SS.settings.freeShippingThreshold) || thresholdFallback;
        if (!threshold) return;
        var remaining = threshold - total;
        if (remaining > 0) {
          nudge.textContent = (nudge.dataset.awayTemplate || '').replace('[amount]', money(remaining));
        } else {
          nudge.textContent = nudge.dataset.unlockedText || '';
        }
      }

      function updateTotals() {
        var v = currentVariant();
        if (!v) return;
        var total = v.price * getQty();
        Array.prototype.forEach.call(root.querySelectorAll('[data-ss-atc-total]'), function (el) {
          el.textContent = money(total);
        });
        updateNudge(total);
      }

      function updateButtons(v) {
        var ok = !!v && v.available;
        buyBtns.forEach(function (btn) {
          var label = btn.querySelector('[data-ss-atc-label]');
          var extra = btn.querySelector('[data-ss-atc-extra]');
          btn.disabled = !ok;
          btn.classList.toggle('ss-btn--primary', ok);
          btn.classList.toggle('ss-btn--dashed', !ok);
          if (label) {
            if (ok) {
              label.textContent = btn.dataset.addText;
            } else if (v) {
              label.textContent = btn.dataset.soldOutText;
            } else {
              label.textContent = btn.dataset.unavailableText;
            }
          }
          if (extra) extra.hidden = !ok;
        });
        if (notify) notify.hidden = !v || v.available;
      }

      function updateStock(v) {
        var scarce = isScarce(v);
        if (stockCard) stockCard.hidden = !scarce;
        if (scarce) {
          if (stockQty) stockQty.textContent = v.inventory_quantity;
          if (stockFill) {
            stockFill.style.width = Math.min(100, Math.max(6, v.inventory_quantity * 5)) + '%';
          }
        }
        if (stickyStock) {
          stickyStock.textContent = scarce ? ' · only ' + v.inventory_quantity + ' left from this print run' : '';
        }
      }

      function updatePrice(v) {
        if (!v) return;
        if (priceBox) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          var html =
            '<span class="ss-price ss-price--large' +
            (sale ? ' ss-price--sale' : '') +
            '"><span class="ss-price__current">' +
            money(v.price) +
            '</span>' +
            (sale
              ? '<s class="ss-price__was"><span class="visually-hidden">' +
                (priceBox.dataset.regularLabel || '') +
                '</span>' +
                money(v.compare_at_price) +
                '</s>'
              : '') +
            '</span>';
          priceBox.innerHTML = html;
        }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
      }

      function scrollToMedia(v, smooth) {
        if (!track || !v || !v.media_id) return;
        var slide = track.querySelector('[data-media-id="' + v.media_id + '"]');
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      }

      function updateUrl(v) {
        if (!v || !window.history || !window.history.replaceState) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {
          /* noop */
        }
      }

      function applyVariant(v) {
        if (idInput) idInput.value = v ? v.id : '';
        updatePrice(v);
        updateButtons(v);
        updateStock(v);
        updateTotals();
        scrollToMedia(v, true);
        if (v) updateUrl(v);
      }

      /* option pills */
      var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-option]'));
      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = [];
          optionInputs.forEach(function (radio) {
            if (radio.checked) selected[Number(radio.dataset.optionPosition) - 1] = radio.value;
          });
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var all = true;
            for (var j = 0; j < selected.length; j++) {
              if (v.options[j] !== selected[j]) {
                all = false;
                break;
              }
            }
            if (all) {
              match = v;
              break;
            }
          }
          applyVariant(match);
        });
      });

      /* quantity stepper */
      Array.prototype.forEach.call(root.querySelectorAll('[data-ss-step]'), function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var next = Math.min(99, Math.max(1, getQty() + Number(btn.dataset.ssStep)));
          qtyInput.value = next;
          if (qtyValue) qtyValue.textContent = next;
          updateTotals();
        });
      });

      /* gallery dots */
      if (track && dots.length) {
        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
              dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === index);
              });
            });
          },
          { passive: true }
        );
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = Number(dot.dataset.index) || 0;
            track.scrollTo({
              left: index * track.clientWidth,
              behavior: reduceMotion ? 'auto' : 'smooth'
            });
          });
        });
      }

      /* sticky buy bar reveal */
      if (sticky && mainAtc && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            document.body.style.paddingBottom = show ? sticky.offsetHeight + 'px' : '';
          },
          { threshold: 0 }
        );
        observer.observe(mainAtc);
      }

      /* align gallery with the selected variant on load */
      scrollToMedia(currentVariant(), false);
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ss-main-product]'), initMainProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  /* Klaviyo ride-along: when a list ID is configured in theme settings, the
     signup is also subscribed to that Klaviyo list via the client API so the
     welcome flow fires instantly. The native Shopify subscription proceeds
     untouched; keepalive lets the request survive the form navigation. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ss-klaviyo-list]');
    if (!form) return;
    var listId = form.getAttribute('data-ss-klaviyo-list');
    var companyId = form.getAttribute('data-ss-klaviyo-company');
    var emailInput = form.querySelector('input[type="email"]');
    if (!listId || !companyId || !emailInput || !emailInput.value) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'ShySprout theme newsletter',
              profile: { data: { type: 'profile', attributes: { email: emailInput.value } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).catch(function () {});
    } catch (err) {
      /* never block the native signup */
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hydrate = function (el) {
      if (!el || el.dataset.ssRelatedLoaded === 'true') return;
      var url = el.dataset.url;
      if (!url) return;
      el.dataset.ssRelatedLoaded = 'true';
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-ss-related]');
          if (fresh && fresh.innerHTML.trim().length > 0) {
            el.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {
          /* leave the section hidden if recommendations are unavailable */
        });
    };

    var targets = document.querySelectorAll('[data-ss-related]');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              observer.unobserve(entry.target);
              hydrate(entry.target);
            }
          });
        },
        { rootMargin: '600px 0px' }
      );
      targets.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      targets.forEach(hydrate);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-ss-related]');
      if (el) {
        el.dataset.ssRelatedLoaded = '';
        hydrate(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
